var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{attrs:{"label":_vm.element.text,"outlined":"","dense":"","clearable":"","rules":_vm.element.mandatory ? _vm.rules : [],"error":_vm.error},on:{"input":_vm.emitAnswerUpdate},model:{value:(_vm.element.answer),callback:function ($$v) {_vm.$set(_vm.element, "answer", $$v)},expression:"element.answer"}})
}
var staticRenderFns = []

export { render, staticRenderFns }